import {
  saveRecord,
  saveRecords,
  getByValue,
  getByValues,
  getFilteredByMultiValue,
  getFilteredByValue,
  getFilteredByValues,
  remove,
  removeMultiple,
  patchRecord,
} from "../utils/object.repository.utils";
import { BaseClientRepository } from "./base.client.repository";

export abstract class MapClientRepository<T> extends BaseClientRepository<{
  [key: string]: T;
}> {
  private setter = (value: { [key: string]: T }) => super.set(value);

  public override get(): { [key: string]: T } {
    return super.get() || {};
  }

  public getById(id: string): T {
    const previous = this.get();
    return previous[id];
  }

  public saveRecords(records: {
    [key: string]: T;
  }): Promise<{ [key: string]: T }> {
    const previous = this.get();
    return saveRecords(this.setter, records, previous);
  }

  public saveRecord(key: string, record: T): Promise<{ [key: string]: T }> {
    const previous = this.get();
    return saveRecord(key, record, this.setter, previous);
  }

  public patchRecord(id: string, fieldsToPatch: Partial<T>): Promise<T> {
    const previous = this.get();
    const record = this.getById(id);
    return patchRecord(id, record, fieldsToPatch, previous, this.setter);
  }

  public getLength(): number {
    const records = super.get();
    return Object.keys(records).length;
  }

  public getAsArray(): T[] {
    const records = super.get();
    if (records == null) {
      return [];
    }
    return Object.values(records);
  }

  public getAsMap(): { [key: string]: T } {
    return this.get();
  }

  public getByValue(key: string, value: any): T {
    const records = this.get();
    return getByValue(key, value, records);
  }

  public getByValues(keys: string[], values: any[]): T {
    const records = this.get();
    return getByValues(keys, values, records);
  }

  public getFilteredByValue(key: string, value: any): { [key: string]: T } {
    const records = this.get();
    return getFilteredByValue(key, value, records);
  }

  public getFilteredByMultiValue(
    key: string,
    values: any[],
  ): { [key: string]: T } {
    const records = this.get();
    return getFilteredByMultiValue(key, values, records);
  }

  public getFilteredByValues(
    keys: string[],
    values: any[],
  ): { [key: string]: T } {
    const records = this.get();
    return getFilteredByValues(keys, values, records);
  }

  public remove(key: string): Promise<{ [key: string]: T }> {
    const records = this.get();
    return remove(key, this.setter, records);
  }

  public removeMultiple(values: string[]): Promise<{ [key: string]: T }> {
    const records = this.get();
    return removeMultiple(values, this.setter, records);
  }
}
